import React, { Fragment, memo } from "react";
import { NavComponent, FeaturedAdTiles, Footer, GenericComponent, GenericFeed } from "src/component-placeholders";

export const PortalLoading = memo(() => {
  return (
    <Fragment>
      <NavComponent />
      <FeaturedAdTiles />
      <GenericComponent />
      <GenericComponent />
      <GenericFeed />
      <Footer />
    </Fragment>
  );
});
